import { render, staticRenderFns } from "./404.vue?vue&type=template&id=95d9c2a4"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=95d9c2a4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95d9c2a4')) {
      api.createRecord('95d9c2a4', component.options)
    } else {
      api.reload('95d9c2a4', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=95d9c2a4", function () {
      api.rerender('95d9c2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/404.vue"
export default component.exports